module.exports = __webpack_public_path__ + "static/img/bg_education.9f3e3b15.png";